module.exports = __webpack_public_path__ + "static/hourglass.2bd66a3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/hourglass.png
// module id = 1290
// module chunks = 168707334958949